<div *ngIf="noteCount > 0">
    <h3>Notes</h3>
    <eic-project-notes-header
        [projectId]="projectId"
        [showMemberNoteControls]="showMemberNoteControls"
        (selectedNoteTypes_change)="selectedNoteTypes_change($event)">
    </eic-project-notes-header>

    <!--
    eic-project-notes-list will take in the list of Project notes
    (does that  make this a smart component?) and, via an ngFor,
    display then all in a list

    The list component will have to take account of the different
    not formats needed to account for:
        * Regular Notes
        * Member Notes
        * Analyst Opinion
-->
    <eic-project-notes-list [showMemberNoteControls]="showMemberNoteControls"></eic-project-notes-list>
</div>
